import { POST_EVENT } from '../types/event'
import * as log from 'loglevel'

function getOptions(ctx) {
  return {
    headers: {
      Authorization: ctx.rootState.user.token
    }
  }
}

// {
//   eventType: 'leave_room',
//   chunkId: params.chunkId, // problem id
//   userId: params.userId // user id
// }

const actions = {
  [POST_EVENT](ctx, { payload }) {
    let options = getOptions(ctx)
    try {
      return ctx.rootState.api.postEvent({
        payload,
        options
      })
    } catch (err) {
      log.error(err)
    }
  }
}

export default {
  actions
}
